// extracted by mini-css-extract-plugin
export var brand = "_ad-9";
export var compact = "_ad-6";
export var extraSmall = "_ad-7";
export var icon = "_ad-0";
export var large = "_ad-4";
export var light = "_ad-1";
export var medium = "_ad-5";
export var outline = "_ad-b";
export var primaryDark = "_ad-a";
export var primaryLight = "_ad-8";
export var primaryModern = "_ad-c";
export var success = "_ad-2";
export var successSolid = "_ad-3";